import api from "../utils/apiCliente";

export const registerCliente = async (data) => {
  const res = await api.post("/api/authCliente/cliente/register", {
    nombre: data.nombre,
    apellido: data.apellido,
    correo: data.correo,
    usuario: data.usuario,
    password: data.password,
    tipo_cliente: data.tipo_cliente,
    // El backend los ignora si la cuenta es individual.
    razon_social: data.razon_social,
    codigo_telefono: data.codigo_telefono,
    telefono: data.telefono,
  });

  return res.data;
};

export const loginCliente = async (usuario, password) => {
  const res = await api.post("/api/authCliente/cliente/login", {
    usuario,
    password,
  });

  return res.data;
};

export const logoutCliente = () => {
  localStorage.removeItem("cliente_token");
  localStorage.removeItem("cliente");
};


export const getClienteLocal = () => {
  const cliente = localStorage.getItem("cliente");
  return cliente ? JSON.parse(cliente) : null;
};


export const isClienteAuthenticated = () => {
  return Boolean(localStorage.getItem("cliente_token"));
};

export const validateClienteSession = async () => {
  try {
    await api.get("/api/authCliente/cliente/authorize");
    return { ok: true };
  } catch (err) {
    // El interceptor de apiUser rechaza con un Error propio y pone el codigo
    // en err.status: no hay .response que leer. Con err?.response?.status
    // esto era siempre undefined, nunca entraba en el 401 y una sesion
    // vencida se daba por buena.
    const status = err?.status ?? err?.response?.status;

    if (status === 401 || status === 403) {
      logoutCliente();
      return { ok: false, reason: "invalid_or_expired" };
    }

    // Sin red o con el server caido no se cierra la sesion: el token puede
    // estar perfecto y el problema ser de conexion.
    return { ok: true, warning: "network_or_server" };
  }
};